<template>
    <div class="border rounded-lg h-full"
         :class="{'bg-light-module border-light-border': !darkMode, 'bg-dark-module border-dark-border': darkMode}">
        <div class="px-5 pt-5 pb-4">
            <div class=" flex items-center justify-between">
                <h5 class="text-primary-500 text-sm uppercase font-semibold leading-tight">
                    Task Notes</h5>
                <button
                    class="ml-2 transition duration-200 inline-flex items-center font-semibold bg-grey-475 hover:bg-grey-500 text-white text-sm font-medium focus:outline-none py-2 rounded-md px-5"
                    @click="showNoteModal">
                    Add Note
                </button>
            </div>
        </div>
        <div class="border-t border-b h-100 overflow-y-auto p-4"
             :class="{'bg-light-background  border-light-border': !darkMode, 'bg-dark-background border-dark-border': darkMode, 'flex flex-col items-center justify-center': loading}">
            <div v-if="taskNotes.length > 0" class="flow-root">
                <ul role="list" class="-mb-8">
                    <li v-for="(taskNote, idx) in taskNotes">
                        <div class="relative pb-8">
                            <span v-if="idx !== taskNotes.length - 1" class="absolute top-12 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"
                                style="height: calc(100% - 3.5rem);"
                            ></span>
                            <div class="relative flex items-start space-x-3">
                                <div class="relative">
                                    <svg class="h-10 w-10 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                         fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd"
                                              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                                              clip-rule="evenodd"/>
                                    </svg>
                                </div>
                                <div class="min-w-0 flex-1">
                                    <div>
                                        <div class="text-sm">
                                            <a
                                                href="#"
                                                class="font-medium"
                                                :class="{'text-gray-900': !darkMode, 'text-white': darkMode}"
                                            >{{ taskNote.user_name }}</a>
                                        </div>
                                        <p class="mt-0.5 text-sm text-gray-500">{{ $filters.dateFromTimestamp(taskNote.date, 'usWithTime') }}</p>
                                    </div>
                                    <div class="mt-2 text-sm"
                                         :class="{'text-gray-700': !darkMode, 'text-gray-200': darkMode}"
                                    >
                                        <p>{{ taskNote.note }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div v-else class="h-full flex flex-col justify-center items-center overflow-y-auto"
                 :class="{'bg-light-background  border-light-border text-grey-200': !darkMode, 'text-blue-500 bg-dark-background border-dark-border': darkMode}">
                <div class="flex justify-center mb-3">
                    <svg class="fill-current" width="80" height="84" viewBox="0 0 80 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M67.3684 4.2C60.4042 4.2 54.7368 9.8532 54.7368 16.8C54.7368 18.9084 55.3095 20.8656 56.2274 22.617L51.5284 28.0854C48.7488 26.2021 45.4654 25.1967 42.1053 25.2C38.9937 25.2 36.1053 26.1072 33.6 27.5772L27.6463 21.6384C28.829 19.515 29.4574 17.129 29.4737 14.7C29.4737 6.594 22.8632 0 14.7368 0C6.61053 0 0 6.594 0 14.7C0 22.806 6.61053 29.4 14.7368 29.4C17.2674 29.4 19.6126 28.7028 21.6926 27.5772L27.6463 33.516C26.1041 36.0799 25.281 39.0101 25.2632 42C25.2632 46.1874 26.8632 49.9758 29.4105 52.9242L22.2863 60.0306L22.3916 60.1356C20.6702 59.2684 18.7706 58.8112 16.8421 58.8C9.8779 58.8 4.21053 64.4532 4.21053 71.4C4.21053 78.3468 9.8779 84 16.8421 84C23.8063 84 29.4737 78.3468 29.4737 71.4C29.4737 69.4008 28.9642 67.5402 28.1347 65.8644L28.24 65.9694L36.4674 57.7626C38.24 58.3926 40.1179 58.8 42.1053 58.8C51.3937 58.8 58.9474 51.2652 58.9474 42C58.9293 39.391 58.2961 36.8228 57.099 34.503L62.3747 28.3626C63.9074 29.0262 65.5916 29.4 67.3684 29.4C74.3326 29.4 80 23.7468 80 16.8C80 9.8532 74.3326 4.2 67.3684 4.2ZM16.8421 75.6C15.7254 75.6 14.6544 75.1575 13.8648 74.3699C13.0752 73.5822 12.6316 72.5139 12.6316 71.4C12.6316 70.2861 13.0752 69.2178 13.8648 68.4301C14.6544 67.6425 15.7254 67.2 16.8421 67.2C17.9588 67.2 19.0298 67.6425 19.8194 68.4301C20.609 69.2178 21.0526 70.2861 21.0526 71.4C21.0526 72.5139 20.609 73.5822 19.8194 74.3699C19.0298 75.1575 17.9588 75.6 16.8421 75.6ZM8.42105 14.7C8.42105 11.2266 11.2547 8.4 14.7368 8.4C18.2189 8.4 21.0526 11.2266 21.0526 14.7C21.0526 18.1734 18.2189 21 14.7368 21C11.2547 21 8.42105 18.1734 8.42105 14.7ZM42.1053 50.4C37.4611 50.4 33.6842 46.6326 33.6842 42C33.6842 37.3674 37.4611 33.6 42.1053 33.6C46.7495 33.6 50.5263 37.3674 50.5263 42C50.5263 46.6326 46.7495 50.4 42.1053 50.4ZM67.3684 21C66.2517 21 65.1808 20.5575 64.3911 19.7698C63.6015 18.9822 63.1579 17.9139 63.1579 16.8C63.1579 15.6861 63.6015 14.6178 64.3911 13.8302C65.1808 13.0425 66.2517 12.6 67.3684 12.6C68.4851 12.6 69.5561 13.0425 70.3457 13.8302C71.1353 14.6178 71.5789 15.6861 71.5789 16.8C71.5789 17.9139 71.1353 18.9822 70.3457 19.7698C69.5561 20.5575 68.4851 21 67.3684 21Z"/>
                    </svg>
                </div>
                <p class="font-semibold">
                    No notes have been added to the task
                </p>
            </div>
        </div>
        <div class="p-3"></div>
        <modal v-if="showAddNoteModal" :small="true" @close="showAddNoteModal = false" :close-text="'Cancel'" :confirm-text="confirmText" @confirm="saveNote">
            <template v-slot:header>
                <h4 class="text-xl font-medium">Add task note</h4>
            </template>
            <template v-slot:content>
                <textarea
                    class="min-h-88 w-full border rounded pl-4  focus:outline-none focus:border focus:border-primary-500 pr-4 py-2"
                    placeholder="Enter notes..." type="text" v-model="taskNote"
                    :class="{'border-grey-200 bg-grey-50': !darkMode, 'border-blue-700 bg-dark-background text-blue-400': darkMode}"/>
            </template>
        </modal>
    </div>
</template>

<script>
import ApiService from "./services/api";
import Pagination from "../Shared/components/Pagination";
import LoadingSpinner from "../Shared/components/LoadingSpinner";
import Modal from "../Shared/components/Modal";

export default {
    name: "TaskNotes",
    components: {Modal, Pagination, LoadingSpinner},
    props: {
        darkMode: {
            type: Boolean,
            default: false
        },
        taskNotes: {
            type: Array,
            default: []
        },
        task: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            api: ApiService.make(),
            loading: false,
            showAddNoteModal: false,
            savingNote: false,
            taskNote: null,
            confirmText: 'Save'
        }
    },
    created() {},
    methods: {
        showNoteModal() {
            this.taskNote = null;
            this.showAddNoteModal = true;
        },
        saveNote() {
            if (!this.taskNote || this.savingNote) {
                return;
            }

            this.savingNote = true;
            this.confirmText = 'Saving...';

            this.api.createTaskNote(this.task.id, this.taskNote).then(resp => this.taskNotes.unshift(resp.data.data.task_note)).finally(() => {
               this.savingNote = false;
               this.confirmText = 'Save';
               this.showAddNoteModal = false;
            });
        }
    }
}
</script>

<style scoped>

</style>
